import styled from "styled-components";

export const Wrapper = styled.div`
    background: #131f28;
    padding: 20px 30px;
    box-shadow: ${props => props.isSmall ? "none" : "0px 0px 15px 1px #00000066"};
    margin-top: ${props => props.isSmall ? "40px" : "0"};

    .ant-upload.ant-upload-select {
        width: 100%;
    }

    .buttons {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }

    .page-change-button {
        background: #3a96b8;
        font-size: 16px;
        color: white;
        border: 0 none;
        border-radius: 3px;
        cursor: pointer;
        border: 2px solid transparent;
        width: 100%;
        padding-bottom: 35px;
        padding-top: 12px;
        :hover {
          border: 2px solid white;
          background: #3a96b8;
          color: white
        }
    }
    .upload-button {
        font-size: 22px;
        padding-bottom: 44px;
        padding-top: 12px;
    }
    .uploader-image {
        width: 100%;
        svg {
            font-size: 55px;
            background-color: #0a4069;
            border-radius: 22px;
            fill: #fff;
        }
    }
    /* .ant-input::placeholder {
    font-size: 15px;
  } */
    #months::placeholder {
        font-size: 15px;
    }
    .ant-input-suffix {
        font-size: 15px;
        opacity: 0.6;
    }
    .line-container {
        position: relative;
        margin: 20px 0px 0px;
        .line-divider {
            height: 1px;
            background: white;
        }
        .line-text {
            background: #131f28;
            position: relative;
            top: -10px;
            color: white;
            padding: 0px 19px;
        }
    }

    .header-container-background{
        background-color: white;
        opacity:1;
        color: black;
    }
   
    .upload-btn-background-overlay{
        background-color: white;
        color:black;
        opacity:1;
        font-size: 18px;
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-header-text {
        /* flex: none; */
        color: black;
        font-size: 18px;
    }
    .ant-collapse {
        background-color: #131f28;
    }
    .Annual-Usage {
        width: 20px;
    }
    .border {
        border: 1px solid lightgrey;
        Input {
            color: black;
        }
    }
    .anticon svg {
        fill: #fff;
    }
    .iMbEpF {
        padding: 8px 11px;
    }
    /* .ant-collapse-content > .ant-collapse-content-box {
        
    width: 50%;
    border: 10px solid red;
    margin-top: 8px;
    height: -34%;
    height: 70px;
    margin-bottom: 8px;} */
    .ant-select-selector {
        border: 2px solid #fff !important;
        background-color: white !important;
        font-size: 18px;
        /* padding-top: 10px; */
        color: black !important;
        /* height: 44px; */
    }
    .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
        padding-top: 7px;
    }
    .ant-select-selection-placeholder {
        color: white !important;
        padding-top: 5px;
    }
    .ant-select-selection-search {
        padding-top: 5px;
    }
    .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
        background-color:white;
        color:black;
        height: 47px;
    }
`;
